import { render, staticRenderFns } from "./BookShelfPage.vue?vue&type=template&id=52907092&scoped=true&"
import script from "./BookShelfPage.vue?vue&type=script&lang=js&"
export * from "./BookShelfPage.vue?vue&type=script&lang=js&"
import style0 from "./BookShelfPage.vue?vue&type=style&index=0&id=52907092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52907092",
  null
  
)

export default component.exports